export const version = {
  timeStamp: '2026-10-15 12:30:49 PM -03',
  version: '0.0.13-20261015123049',
}
